import React from "react";

const PageNotFound = () => {
  return <p>The requested page doesn't exist.</p>;
};

export default PageNotFound;
